module.exports = __webpack_public_path__ + "img/highlight_slice.fb218ddb.svg";